import config   from 'config';
import UAParser from 'ua-parser-js';
let parser = new UAParser();

class Utils {

  screen() {
    return {
      'sp': $(window).innerWidth() <= config.screen.sp,
      'tablet': $(window).innerWidth() <= config.screen.tablet
    }
  }

  sleep(msec) {
    return new Promise(resolve => setTimeout(resolve, msec));
  }

  ua() {
    return parser.getResult();
  }

  getPageOptions() {
    let options = config.pageOptions;
    let pathName = location.pathname;
    let parts = location.href.split('/');
    let lastSegment = parts.pop() || parts.pop();
    let getOptions = null;

    if (window.BROTHER.page == 'top') {
      getOptions = _.findWhere(options, {name: 'top'});
    } else if ( /\/brand-story\/story-[0-9]{2}\//.test(pathName) ) {
      // ストーリ詳細ページか否か
      getOptions = _.findWhere(options, {name: 'brand-story-detail'});
    } else if ( /\/history\/[0-9]{4}\.html/.test(pathName) ) {
      // ヒストリー詳細ページか否か
      getOptions = _.findWhere(options, {name: 'history-detail'});
    } else {
      if ( /#year[0-9]{4}/.test(lastSegment) ) {
        getOptions = _.findWhere(options, {name: 'history'});
      } else {
        getOptions = _.findWhere(options, {name: lastSegment});
      }
    }

    return getOptions ? getOptions.options : null;
  }

  /**
   * ランダムな数(float)
   * @param  {[type]} min 最小値(float)
   * @param  {[type]} max 最大値(float)
   * @return {[type]}     [description]
   */
  random(min, max) {
    return Math.random() * (max - min) + min;
  }


  /**
   * ランダムな数(int)
   * @param  {[type]} min 最小値(float)
   * @param  {[type]} max 最大値(float)
   * @return {[type]}     [description]
   */
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }


  /**
   * 配列内の値をランダムに取得
   * @param  {[type]} arr [description]
   * @return {[type]}     [description]
   */
  randomArr(arr) {
    return arr[this.randomInt(0, arr.length - 1)];
  }


  /**
   * 配列のシャッフル
   * @param  {[type]} arr [description]
   * @return {[type]}     [description]
   */
  shuffle(array) {
    let n = array.length, t, i;

    while (n) {
      i = Math.floor(Math.random() * n--);
      t = array[n];
      array[n] = array[i];
      array[i] = t;
    }

    return array;
  }


  /**
   * 2点間の距離を返す
   * @param  {[type]} x1 [description]
   * @param  {[type]} y1 [description]
   * @param  {[type]} x2 [description]
   * @param  {[type]} y2 [description]
   * @return {[type]}    [description]
   */
  distance(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  }


  /**
   * 角度をラジアンに変換
   * @param  {[type]} degree [description]
   * @return {[type]}        [description]
   */
  radian(degree) {
    return degree * Math.PI / 180;
  }


  /**
   * ラジアンを角度に変換
   * @param  {[type]} radian [description]
   * @return {[type]}        [description]
   */
  degree(radian) {
    return radian / Math.PI / 180;
  }
};


module.exports = new Utils();



// WEBPACK FOOTER //
// ./src/js/common/Utils.js